var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex q-mt-lg justify-between"},[_vm._t("back",[(!_vm.hideBack)?_c('QBtn',{attrs:{"label":"Back","outline":"","icon":this.backIcon,"color":"grey-8","ripple":false},on:{"click":_vm.goBack}}):_vm._e()]),_vm._t("next")],2)}
var staticRenderFns = []

export { render, staticRenderFns }